module.exports = __webpack_public_path__ + "static/2_1_search-1_RO-33548bad4fe1c57fd8d36f5544ef8d93.svg";